module.exports = __webpack_public_path__ + "static/man-rr-27423feba95371232e996b486951744d.jpg";